import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {AnalyticsWatcherConfig, AnalyticsWatcher} from "./analytics_watcher"

export const analyticsWatcherLoader = function (options = {}) {
    componentLoader(componentConfig(AnalyticsWatcher, AnalyticsWatcherConfig.componentTypeKey, AnalyticsWatcherConfig.baseHtmlClass), options);
};

